import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AccountService } from 'src/app/services/account.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { CustomValidators } from 'src/app/lib/customer-validators';

@Component({
  selector: 'app-complete-recovery',
  templateUrl: './complete-recovery.component.html',
  styleUrls: ['./complete-recovery.component.scss']
})
export class CompleteRecoveryComponent implements OnInit {
  private token;
  public savingPassword = false;
  public passwordForm: FormGroup;

  constructor(
    private route: ActivatedRoute,
    private accountService: AccountService,
    private router: Router
  ) {
    this.route.params.subscribe(params => {
      this.token = params['id'];
    });

    this.passwordForm = new FormGroup({
      'password': new FormControl(null, [Validators.required,Validators.minLength(8)]),
      'password_confirmation': new FormControl(null, Validators.required),
    },{
      validators: CustomValidators.MatchPassword
    });
  }

  ngOnInit() {
  }

  confirm(){
    this.savingPassword = true;
    this.accountService.confirmPasswordReset(this.token,this.passwordForm.get('password').value,this.passwordForm.get('password_confirmation').value).subscribe(res=>{
      this.savingPassword = true;
      if(res=="success"){
        this.router.navigate(['/login']);
      }
    })
  }
}
